export function SchemeLabel(sc) {
    return !!sc ? `${sc.code} ${sc.name}` : "";
}

export function ProgramsLabel(pr) {
    return !!pr ? `${pr.scheme.code} ${pr.scheme.name} ${pr.insuree.otherNames} ${pr.insuree.lastName}` : "";
}